import { render, staticRenderFns } from "./FixedBanner.vue?vue&type=template&id=12827a6a&scoped=true&"
import script from "./FixedBanner.vue?vue&type=script&lang=js&"
export * from "./FixedBanner.vue?vue&type=script&lang=js&"
import style0 from "./FixedBanner.vue?vue&type=style&index=0&id=12827a6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12827a6a",
  null
  
)

export default component.exports